import React from "react";
import "./App.css";
import { ConfigProvider } from "antd";
import Login from "./login/Login";
import {
  Route,
  BrowserRouter,
  Routes,
  Navigate,
  Router,
} from "react-router-dom";
import Main from "./main/Main";
import Companies from "./company/Companies";
import CompanyDetailed from "./company/CompanyDetailed";
import Translations from "./translation/Translations";
import TranslationDetailed from "./translation/TranslationDetailed";
import AddTranslation from "./translation/AddTranslation";
import UpdateTranslation from "./translation/UpdateTranslations";
import Dashboard from "./dashboard/Dashboard";
import Sources from "./sources/Sources";
import UpdateSource from "./sources/UpdateSource";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AddSource from "./sources/AddSource";
import AllowUpdateSource from "./allowed-source/AllowUpdateSource";
import AllowAddSource from "./allowed-source/AllowAddSource";
const queryClient = new QueryClient();
interface ProtectedRouteProps {
  element: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/" replace />;
  }
  return element;
};
function App() {
  return (
    <ConfigProvider theme={{ token: { colorPrimary: "#00b96b" } }}>
      <BrowserRouter>
        <Routes>
          {/* Redirect from empty path ("/") to login */}
          <Route path="/" element={<Login />} />
          <Route path="main" element={<ProtectedRoute element={<Main />} />}>
            <Route
              path="companies"
              element={<ProtectedRoute element={<QueryClientProvider client={queryClient}><Companies /></QueryClientProvider>} />}
            />

            <Route
              path="companies/:id"
              element={<ProtectedRoute element={<CompanyDetailed />} />}
            />

            <Route
              path="translations"
              element={<ProtectedRoute element={<Translations />} />}
            />
            <Route
              path="translations/detail/:key"
              element={<ProtectedRoute element={<TranslationDetailed />} />}
            />
            <Route
              path="translations/add_translation"
              element={<ProtectedRoute element={<AddTranslation />} />}
            />
            <Route
              path="translations/update_translation"
              element={<ProtectedRoute element={<UpdateTranslation />} />}
            />
            <Route
              path="dashboard"
              element={<ProtectedRoute element={<Dashboard />} />}
            />
            <Route
              path="sources"
              element={<ProtectedRoute element={<Sources />} />}
            />
            <Route
              path="sources/update"
              element={<ProtectedRoute element={<UpdateSource />} />}
            />
            <Route
              path="sources/add"
              element={<ProtectedRoute element={<AddSource />} />}
            />
            <Route
             path="companies/:companyId/allowed-source/:sourceId/update"
             element={<ProtectedRoute element={<AllowUpdateSource />} />}
            /><Route
            path="companies/:id/allowed-source/add"
            element={<ProtectedRoute element={<AllowAddSource />} />}
           />
          </Route>
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
